import cn from 'classnames';

const Image = (props) => {
    const { imageSrc, imageAlt, className } = props;
    return (
        <img src={imageSrc} alt={imageAlt || ""} className={cn(className, "inline")}/>
    )
}

export default Image;
